define((require) => {
    "use strict";

    var EditorActivity  = require("editor/ui/experience/editor/activity/EditorActivity"),
        _               = require("underscore");

    /**
     * An activity representing the creation of a widget.
     *
     * @class WidgetDeletedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _sceneModel: null,

        /**
         *
         * @type {Array}
         */
        _widgetModels: null,

        /**
         *
         * @type {Array}
         */
        _widgetModelProperties: null,

        constructor: function(widgetModels, sceneModel) {
            widgetModels = _.isArray(widgetModels) ? widgetModels : [widgetModels];
            this._widgetModels = _.invoke(widgetModels, "clone", {duplicate: true});
            this._sceneModel = sceneModel;
        },

        _onUndo: function() {
            _.each(this._widgetModels, function(widgetModel) {
                this._sceneModel.addWidget(widgetModel, {cause: "undo"});
            }, this);
        },

        _onRedo: function() {
            _.each(this._widgetModels, function(widgetModel) {
                this._sceneModel.deleteWidget(widgetModel, {cause: "redo"});
            }, this);
        },

        dispose: function() {
            this._widgetModels = null;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/WidgetDeletedActivity.js